import { OAuthFlowsElement } from '@swagger-api/apidom-ns-openapi-3-0';
class OAuthFlows extends OAuthFlowsElement {}
export default OAuthFlows;